import React, { useEffect, useState } from "react";
import "./SchoolERP.css";
import schoolImage from "../../Asset/Yashavi.png";
import { submitProductEnquiry } from "../../api";
import toast, { Toaster } from "react-hot-toast";

const workflow = [
  { number: "01", title: "Requirement Discussion", text: "Sabse pehle school ke users, daily operations aur business requirements ko detail mein understand kiya jata hai.", tag: "DISCOVER" },
  { number: "02", title: "UI / UX Planning", text: "Complete user flow, dashboard structure aur responsive interface ko development se pehle carefully plan kiya jata hai.", tag: "DESIGN" },
  { number: "03", title: "Frontend Development", text: "React.js ke through fast, modern aur responsive interfaces develop kiye jate hain jo different devices par smoothly work karein.", tag: "BUILD" },
  { number: "04", title: "Backend & API", text: "Python backend, APIs aur database ke through authentication, business logic aur data management implement hota hai.", tag: "CONNECT" },
  { number: "05", title: "Testing & Security", text: "Application ke features, forms, validations, permissions aur responsive behaviour ko thoroughly test kiya jata hai.", tag: "VERIFY" },
  { number: "06", title: "Deployment & Support", text: "Final application ko production environment mein deploy karke future updates aur support ke liye ready kiya jata hai.", tag: "LAUNCH" },
];

const modules = [
  { icon: "ST", number: "01", title: "Student Management", text: "Student profiles, admission details, documents, academic records aur complete student information ek organized system mein.", features: ["Admissions", "Profiles", "Documents"] },
  { icon: "AT", number: "02", title: "Attendance", text: "Daily attendance, monthly records aur attendance reports ko simple dashboard ke through manage kiya ja sakta hai.", features: ["Daily Entry", "Reports", "Analytics"] },
  { icon: "FE", number: "03", title: "Fees Management", text: "Fee collection, pending payments, receipts aur payment records ko organized way mein maintain karne ke liye.", features: ["Collection", "Receipts", "Pending"] },
  { icon: "EX", number: "04", title: "Examination", text: "Exam schedules, marks entry, results aur student performance ko efficiently manage karne ke liye dedicated module.", features: ["Schedule", "Marks", "Results"] },
  { icon: "TT", number: "05", title: "Timetable", text: "Classes, teachers, subjects aur periods ko manage karne ke liye structured timetable workflow.", features: ["Classes", "Subjects", "Teachers"] },
  { icon: "NT", number: "06", title: "Notice & Updates", text: "Important school announcements, notices aur updates ko different users tak easily communicate karne ke liye.", features: ["Notices", "Events", "Updates"] },
  { icon: "CM", number: "07", title: "Communication", text: "School, teachers, students aur parents ke beech important information share karne ke liye connected communication flow.", features: ["Parents", "Teachers", "Students"] },
  { icon: "RP", number: "08", title: "Reports & Insights", text: "Management ko useful information quickly understand karne ke liye reports aur data-based insights.", features: ["Reports", "KPIs", "Insights"] },
];

const securityFeatures = [
  { icon: "AU", number: "01", title: "Role-Based Access", text: "Admin, teacher, student aur parent ke liye permissions ko role ke according structure kiya ja sakta hai.", tag: "ACCESS" },
  { icon: "VA", number: "02", title: "Form Validation", text: "Important forms aur inputs ko proper validation ke saath handle karke data quality improve ki ja sakti hai.", tag: "VALIDATE" },
  { icon: "DB", number: "03", title: "Data Protection", text: "Sensitive school information ko controlled workflows aur secure application practices ke through manage kiya jata hai.", tag: "PROTECT" },
  { icon: "TS", number: "04", title: "Testing Checks", text: "Features, permissions, forms aur responsive behaviour ko release se pehle systematically test kiya jata hai.", tag: "TEST" },
];

const userRoles = [
  { icon: "AD", number: "01", title: "Admin", text: "Students, fees, reports, notices aur overall school operations par centralized control.", features: ["Management", "Reports", "Settings"] },
  { icon: "TE", number: "02", title: "Teacher", text: "Attendance, classes, timetable, marks aur classroom related workflows ke liye focused tools.", features: ["Classes", "Attendance", "Marks"] },
  { icon: "ST", number: "03", title: "Student", text: "Academic information, timetable, results aur important school updates ko easily access karne ke liye.", features: ["Results", "Timetable", "Updates"] },
  { icon: "PA", number: "04", title: "Parent", text: "Child ki attendance, academic updates, notices aur fee related information ko track karne ke liye.", features: ["Progress", "Notices", "Fees"] },
];

const deliverySteps = [
  { icon: "PL", number: "01", title: "Plan", text: "Requirements, user roles aur project scope ko clearly define kiya jata hai." },
  { icon: "BU", number: "02", title: "Build", text: "UI, frontend, backend, APIs aur required modules ko structured way mein develop kiya jata hai." },
  { icon: "QA", number: "03", title: "Review", text: "Testing, feedback aur refinements ke through application experience ko improve kiya jata hai." },
  { icon: "GO", number: "04", title: "Go Live", text: "Final system ko deployment ke liye prepare karke future support aur updates ke liye ready kiya jata hai." },
];

const reviews = [
  { quote: "The development process was clear from requirement discussion to final delivery. Every stage was explained properly.", name: "School Administrator", role: "Sample Client Review" },
  { quote: "The application makes daily school operations much more organized and gives different users their own workflow.", name: "Academic Coordinator", role: "Sample Client Review" },
  { quote: "We liked the clean interface and the way the system was planned around our actual school requirements.", name: "School Management", role: "Sample Client Review" },
  { quote: "The system structure makes it easier to understand students, attendance, fees and academic information from one place.", name: "School Operations", role: "Sample Client Review" },
];

function Landing() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: "", school: "", email: "", phone: "", message: "" });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".yt-sms-reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("yt-sms-visible");
        });
      },
      { threshold: 0.1 }
    );
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    setMenuOpen(false);
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation — email ya phone mein se ek zaroori
    if (!formData.email.trim() && !formData.phone.trim()) {
      toast.error("Please enter either Email or Phone number.");
      return;
    }

    setLoading(true);

    try {
      const result = await submitProductEnquiry({
        name: formData.name,
        email: formData.email || "",
        phone: formData.phone || "",
        company: formData.school,
        product: "School",
        message: formData.message,
      });

      if (result.status === "success") {
        // ✅ Toast with name
        toast.success(
          `Congratulations ${formData.name}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );
        setFormData({ name: "", school: "", email: "", phone: "", message: "" });
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const reviewItems = [...reviews, ...reviews];

  return (
    <div className="yt-sms-single-page">
      {/* ✅ Toast Container */}
<Toaster
  position="top-right"
  containerStyle={{ top: 80, zIndex: 99999 }}
  toastOptions={{ duration: 5000, style: { fontSize: "13px", borderRadius: "10px", maxWidth: "380px" } }}
/>

      {/* HEADER */}
      <header className={`yt-sms-site-header ${scrolled ? "yt-sms-header-scrolled" : ""}`}>
        <div className="yt-sms-navbar-header">
          <button className="yt-sms-navbar-logo" onClick={() => scrollToSection("home")} aria-label="Go to home">
            <span className="yt-sms-navbar-logo-image"><img src={schoolImage} alt="YashviTech IT Solution Pvt. Ltd." /></span>
          </button>

          <nav className={`yt-sms-desktop-nav ${menuOpen ? "yt-sms-mobile-open" : ""}`}>
            <button className="yt-sms-navbar-link yt-sms-active" onClick={() => scrollToSection("home")}>Home</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("process")}>Process</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("reviews")}>Reviews</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("modules")}>Modules</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("analytics")}>Analytics</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("security")}>Security</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("roles")}>Roles</button>
            <button className="yt-sms-navbar-link" onClick={() => scrollToSection("delivery")}>Delivery</button>
          </nav>

          <button className="yt-sms-navbar-button" onClick={() => scrollToSection("contact")}>
            <span>Start a Project</span><strong>→</strong>
          </button>

          <button className={`yt-sms-menu-button ${menuOpen ? "yt-sms-menu-active" : ""}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation" aria-expanded={menuOpen}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>

      <main>
        {/* HERO */}
        <section id="home" className="yt-sms-section yt-sms-home-section">
          <div className="yt-sms-hero-background-glow yt-sms-hero-glow-one"></div>
          <div className="yt-sms-hero-background-glow yt-sms-hero-glow-two"></div>

          <div className="yt-sms-home-container">
            <div className="yt-sms-home-left yt-sms-reveal">
              <div className="yt-sms-eyebrow">
                <span className="yt-sms-eyebrow-dot"></span>SCHOOL MANAGEMENT SYSTEM
              </div>

              <h1>We turn a school's <span>idea</span> into a complete digital system.</h1>

              <p className="yt-sms-home-text">
                From requirement discussion and UI/UX planning to React frontend, Python backend, testing and deployment — Yashvitech builds modern school management solutions around actual business requirements.
              </p>

              <div className="yt-sms-home-actions">
                <button className="yt-sms-home-main-btn" onClick={() => scrollToSection("process")}>Explore Our Process<span>→</span></button>
                <button className="yt-sms-home-outline-btn" onClick={() => scrollToSection("modules")}>Explore Modules<span>↗</span></button>
              </div>

              <div className="yt-sms-home-trust">
                <div className="yt-sms-trust-number">01</div>
                <div>
                  <strong>Requirement → Design → Development → Deployment</strong>
                  <span>A structured journey from idea to working product.</span>
                </div>
              </div>

              <div className="yt-sms-home-bottom-stats">
                <div><strong>08+</strong><span>Core Modules</span></div>
                <div><strong>04</strong><span>User Roles</span></div>
                <div><strong>100%</strong><span>Responsive UI</span></div>
              </div>
            </div>

            <div className="yt-sms-home-right yt-sms-reveal">
              <div className="yt-sms-dashboard-window">
                <div className="yt-sms-dashboard-browser">
                  <div className="yt-sms-browser-dots"><span></span><span></span><span></span></div>
                  <div className="yt-sms-browser-url">yashvitech.school / dashboard</div>
                  <div className="yt-sms-browser-live"><span></span>Live</div>
                </div>

                <div className="yt-sms-dashboard-body">
                  <aside className="yt-sms-dashboard-sidebar">
                    <div className="yt-sms-dashboard-logo">Y</div>
                    <div className="yt-sms-dashboard-menu">
                      <span className="yt-sms-dashboard-menu-active"><i>⌂</i><b>Overview</b></span>
                      <span><i>ST</i><b>Students</b></span>
                      <span><i>AT</i><b>Attendance</b></span>
                      <span><i>FE</i><b>Fees</b></span>
                      <span><i>EX</i><b>Exams</b></span>
                      <span><i>RP</i><b>Reports</b></span>
                    </div>
                  </aside>

                  <div className="yt-sms-dashboard-main">
                    <div className="yt-sms-dashboard-top">
                      <div><small>ADMIN DASHBOARD</small><h3>Good morning, Admin</h3></div>
                      <div className="yt-sms-dashboard-profile">Y</div>
                    </div>

                    <div className="yt-sms-dashboard-stat-grid">
                      <div className="yt-sms-dashboard-stat-card">
                        <div className="yt-sms-dashboard-stat-icon yt-sms-blue">ST</div>
                        <div><small>Total Students</small><strong>2,486</strong><span className="yt-sms-positive">↑ 8.2%</span></div>
                      </div>
                      <div className="yt-sms-dashboard-stat-card">
                        <div className="yt-sms-dashboard-stat-icon yt-sms-orange">AT</div>
                        <div><small>Attendance</small><strong>94.6%</strong><span className="yt-sms-positive">↑ 4.5%</span></div>
                      </div>
                      <div className="yt-sms-dashboard-stat-card">
                        <div className="yt-sms-dashboard-stat-icon yt-sms-purple">FE</div>
                        <div><small>Fee Collection</small><strong>88.4%</strong><span className="yt-sms-positive">↑ 6.1%</span></div>
                      </div>
                    </div>

                    <div className="yt-sms-dashboard-content-grid">
                      <div className="yt-sms-dashboard-chart-card">
                        <div className="yt-sms-dashboard-card-heading">
                          <div><small>PERFORMANCE</small><strong>School Overview</strong></div>
                          <span>This Year ▾</span>
                        </div>
                        <div className="yt-sms-dashboard-chart">
                          <div className="yt-sms-chart-line yt-sms-chart-line-one"></div>
                          <div className="yt-sms-chart-line yt-sms-chart-line-two"></div>
                          <div className="yt-sms-chart-line yt-sms-chart-line-three"></div>
                          <div className="yt-sms-chart-bars">
                            <span style={{ height: "38%" }}></span>
                            <span style={{ height: "52%" }}></span>
                            <span style={{ height: "47%" }}></span>
                            <span style={{ height: "68%" }}></span>
                            <span style={{ height: "61%" }}></span>
                            <span style={{ height: "78%" }}></span>
                            <span style={{ height: "89%" }}></span>
                          </div>
                        </div>
                        <div className="yt-sms-chart-months">
                          <span>Jan</span><span>Feb</span><span>Mar</span><span>Apr</span><span>May</span><span>Jun</span><span>Jul</span>
                        </div>
                      </div>

                      <div className="yt-sms-dashboard-activity-card">
                        <div className="yt-sms-dashboard-card-heading">
                          <div><small>ACTIVITY</small><strong>Recent Updates</strong></div>
                          <span>•••</span>
                        </div>
                        <div className="yt-sms-activity-item">
                          <span className="yt-sms-activity-icon yt-sms-blue">ST</span>
                          <div><strong>New student added</strong><small>Admission record updated</small></div>
                          <em>2m</em>
                        </div>
                        <div className="yt-sms-activity-item">
                          <span className="yt-sms-activity-icon yt-sms-orange">FE</span>
                          <div><strong>Fee payment received</strong><small>Receipt generated</small></div>
                          <em>8m</em>
                        </div>
                        <div className="yt-sms-activity-item">
                          <span className="yt-sms-activity-icon yt-sms-green">EX</span>
                          <div><strong>Result updated</strong><small>Grade report published</small></div>
                          <em>14m</em>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="yt-sms-hero-floating-card yt-sms-hero-floating-top">
                <div className="yt-sms-floating-check">✓</div>
                <div><strong>System Ready</strong><small>All modules connected</small></div>
              </div>

              <div className="yt-sms-hero-floating-card yt-sms-hero-floating-bottom">
                <div className="yt-sms-floating-progress"><span style={{ width: "88%" }}></span></div>
                <div><strong>88.4%</strong><small>Fee Collection</small></div>
              </div>
            </div>
          </div>
        </section>

        {/* CLIENT REQUIREMENT */}
        <section className="yt-sms-section yt-sms-problem-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-reveal">
              <span className="yt-sms-section-number">01 / CLIENT REQUIREMENT</span>
              <h2>First, we understand<span> the problem.</span></h2>
              <p>Har school ka workflow different hota hai. Isliye ready-made solution dene ke bajay hum pehle actual requirements, users aur daily operations ko understand karte hain.</p>
            </div>

            <div className="yt-sms-problem-grid">
              <div className="yt-sms-problem-visual yt-sms-reveal">
                <div className="yt-sms-discovery-card">
                  <div className="yt-sms-discovery-top"><span>CLIENT DISCOVERY</span><strong>01</strong></div>
                  <div className="yt-sms-discovery-center">
                    <div className="yt-sms-discovery-ring"><div>Y</div></div>
                    <h3>Understand.<br />Plan. Build.</h3>
                    <p>Turning real school workflows into simple digital experiences.</p>
                  </div>
                  <div className="yt-sms-discovery-bottom"><span>Requirements</span><span>Users</span><span>Workflow</span></div>
                </div>
              </div>

              <div className="yt-sms-problem-list yt-sms-reveal">
                <div className="yt-sms-problem-item"><div className="yt-sms-problem-index">01</div><div><h3>Manual Records</h3><p>Registers aur scattered files ki wajah se important information manage karna difficult aur time-consuming ho sakta hai.</p></div><span className="yt-sms-problem-arrow">→</span></div>
                <div className="yt-sms-problem-item"><div className="yt-sms-problem-index">02</div><div><h3>Attendance Tracking</h3><p>Daily attendance ko maintain karna, reports banana aur trends samajhna ek organized digital workflow se easier ho sakta hai.</p></div><span className="yt-sms-problem-arrow">→</span></div>
                <div className="yt-sms-problem-item"><div className="yt-sms-problem-index">03</div><div><h3>Fee Management</h3><p>Paid, pending aur receipt records ko ek connected system mein maintain karne se finance workflow more organized hota hai.</p></div><span className="yt-sms-problem-arrow">→</span></div>
                <div className="yt-sms-problem-item"><div className="yt-sms-problem-index">04</div><div><h3>Communication Gap</h3><p>School, teachers, students aur parents ke important updates ko ek central platform par connect karna easier hota hai.</p></div><span className="yt-sms-problem-arrow">→</span></div>
              </div>
            </div>
          </div>
        </section>

        {/* SOLUTION */}
        <section className="yt-sms-section yt-sms-solution-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-centered yt-sms-reveal">
              <span className="yt-sms-section-number">02 / OUR SOLUTION</span>
              <h2>One system.<span> Every school workflow.</span></h2>
              <p>Client ki requirements ke according ek connected digital ecosystem create kiya jata hai jisme different users ko unke role ke according focused features aur workflows milte hain.</p>
            </div>

            <div className="yt-sms-solution-flow yt-sms-reveal">
              <div className="yt-sms-solution-box"><div className="yt-sms-solution-icon">AD</div><strong>Admin</strong><small>Management</small></div>
              <div className="yt-sms-flow-line"></div>
              <div className="yt-sms-solution-box"><div className="yt-sms-solution-icon">TE</div><strong>Teacher</strong><small>Classroom</small></div>
              <div className="yt-sms-flow-line"></div>
              <div className="yt-sms-solution-box"><div className="yt-sms-solution-icon">ST</div><strong>Student</strong><small>Learning</small></div>
              <div className="yt-sms-flow-line"></div>
              <div className="yt-sms-solution-box"><div className="yt-sms-solution-icon">PA</div><strong>Parent</strong><small>Updates</small></div>
            </div>

            <div className="yt-sms-tech-strip yt-sms-reveal">
              <div><span>FRONTEND</span><strong>React.js</strong></div>
              <div><span>BACKEND</span><strong>Python</strong></div>
              <div><span>API</span><strong>REST API</strong></div>
              <div><span>DATABASE</span><strong>SQL / NoSQL</strong></div>
              <div><span>DESIGN</span><strong>Responsive UI</strong></div>
            </div>
          </div>
        </section>

        {/* WORKFLOW */}
        <section id="process" className="yt-sms-section yt-sms-workflow-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-reveal">
              <span className="yt-sms-section-number">03 / PROJECT WORKFLOW</span>
              <h2>From first meeting<span> to final product.</span></h2>
              <p>Requirement se deployment tak ek structured development process follow kiya jata hai, jisse project ka scope aur direction clear rahe.</p>
            </div>

            <div className="yt-sms-workflow-grid">
              {workflow.map((item, index) => (
                <article className="yt-sms-workflow-card yt-sms-reveal" key={item.number} style={{ transitionDelay: `${index * 70}ms` }}>
                  <div className="yt-sms-workflow-card-top"><span className="yt-sms-workflow-tag">{item.tag}</span><strong>{item.number}</strong></div>
                  <div className="yt-sms-workflow-icon">{item.number}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                  <div className="yt-sms-workflow-card-bottom"><span>Development stage</span><b>→</b></div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* REVIEWS */}
        <section id="reviews" className="yt-sms-section yt-sms-reviews-section">
          <div className="yt-sms-reviews-bg-orb yt-sms-reviews-orb-one"></div>
          <div className="yt-sms-reviews-bg-orb yt-sms-reviews-orb-two"></div>

          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-centered yt-sms-reveal">
              <span className="yt-sms-section-number">04 / CLIENT REVIEWS</span>
              <h2>Built around<span> client experience.</span></h2>
              <p>Development ke different stages par feedback ko consider karke interface, workflow aur overall product experience ko continuously improve kiya jata hai.</p>
            </div>
          </div>

          <div className="yt-sms-reviews-marquee">
            <div className="yt-sms-reviews-track yt-sms-reviews-track-left">
              {reviewItems.map((review, index) => (
                <article className="yt-sms-review-marquee-card" key={`left-${index}`}>
                  <div className="yt-sms-review-card-top"><div className="yt-sms-review-stars">★★★★★</div><span className="yt-sms-review-project">SCHOOL PROJECT</span></div>
                  <div className="yt-sms-review-quote-icon">“</div>
                  <p>{review.quote}</p>
                  <div className="yt-sms-review-card-bottom">
                    <div className="yt-sms-review-avatar">{review.name.charAt(0)}</div>
                    <div className="yt-sms-review-author"><strong>{review.name}</strong><span>{review.role}</span></div>
                    <div className="yt-sms-review-arrow">↗</div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="yt-sms-reviews-marquee yt-sms-reviews-marquee-second">
            <div className="yt-sms-reviews-track yt-sms-reviews-track-right">
              {reviewItems.map((review, index) => (
                <article className="yt-sms-review-marquee-card" key={`right-${index}`}>
                  <div className="yt-sms-review-card-top"><div className="yt-sms-review-stars">★★★★★</div><span className="yt-sms-review-project">DIGITAL SYSTEM</span></div>
                  <div className="yt-sms-review-quote-icon">“</div>
                  <p>{review.quote}</p>
                  <div className="yt-sms-review-card-bottom">
                    <div className="yt-sms-review-avatar">{review.name.charAt(0)}</div>
                    <div className="yt-sms-review-author"><strong>{review.name}</strong><span>{review.role}</span></div>
                    <div className="yt-sms-review-arrow">↗</div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="yt-sms-reviews-bottom yt-sms-reveal">
            <div className="yt-sms-reviews-bottom-item"><span className="yt-sms-reviews-status-dot"></span><strong>Client-focused development</strong></div>
            <div className="yt-sms-reviews-divider"></div>
            <div className="yt-sms-reviews-bottom-item"><span>✦</span><strong>Custom UI / UX</strong></div>
            <div className="yt-sms-reviews-divider"></div>
            <div className="yt-sms-reviews-bottom-item"><span>✓</span><strong>Responsive experience</strong></div>
          </div>
        </section>

        {/* MODULES */}
        <section id="modules" className="yt-sms-section yt-sms-modules-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-reveal">
              <span className="yt-sms-section-number">05 / CORE MODULES</span>
              <h2>Everything the school<span> needs in one place.</span></h2>
              <p>School requirements ke basis par modules ko customize, expand aur connect kiya ja sakta hai. Goal hai daily operations ko ek organized digital workflow mein lana.</p>
            </div>

            <div className="yt-sms-modules-grid">
              {modules.map((module, index) => (
                <article className="yt-sms-module-card yt-sms-reveal" key={module.title} style={{ transitionDelay: `${index * 60}ms` }}>
                  <div className="yt-sms-module-card-top"><span className="yt-sms-module-number">{module.number}</span><div className="yt-sms-module-icon">{module.icon}</div></div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                  <div className="yt-sms-module-features">
                    {module.features.map((feature) => (<span key={feature}>✓ {feature}</span>))}
                  </div>
                  <div className="yt-sms-module-link">Explore module<span>→</span></div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ANALYTICS */}
        <section id="analytics" className="yt-sms-section yt-sms-analytics-section">
          <div className="yt-sms-analytics-background"></div>
          <div className="yt-sms-section-container">
            <div className="yt-sms-analytics-layout">
              <div className="yt-sms-analytics-copy yt-sms-reveal">
                <span className="yt-sms-section-number">06 / DATA & ANALYTICS</span>
                <h2>Turn school data into<span> useful insights.</span></h2>
                <p>Management ko important information quickly understand karne ke liye reports, KPIs aur analytics dashboards develop kiye ja sakte hain. Iss data ko readable aur actionable format mein present kiya ja sakta hai.</p>
                <div className="yt-sms-analytics-stats">
                  <div><strong>94.6%</strong><span>Attendance</span></div>
                  <div><strong>88.4%</strong><span>Fee Collection</span></div>
                  <div><strong>91%</strong><span>Performance</span></div>
                </div>
                <small className="yt-sms-demo-note">* Sample project/demo data shown for presentation.</small>
              </div>

              <div className="yt-sms-chart-card yt-sms-reveal">
                <div className="yt-sms-chart-header">
                  <div><small>MONTHLY OVERVIEW</small><strong>School Performance</strong></div>
                  <span className="yt-sms-chart-badge">+12.4%</span>
                </div>
                <div className="yt-sms-chart">
                  <div className="yt-sms-chart-y"><span>100</span><span>75</span><span>50</span><span>25</span><span>0</span></div>
                  <div className="yt-sms-chart-area">
                    <div className="yt-sms-chart-grid-line yt-sms-one"></div>
                    <div className="yt-sms-chart-grid-line yt-sms-two"></div>
                    <div className="yt-sms-chart-grid-line yt-sms-three"></div>
                    <div className="yt-sms-chart-grid-line yt-sms-four"></div>
                    <div className="yt-sms-chart-bars">
                      <div><span style={{ height: "48%" }}></span><small>Jan</small></div>
                      <div><span style={{ height: "62%" }}></span><small>Feb</small></div>
                      <div><span style={{ height: "55%" }}></span><small>Mar</small></div>
                      <div><span style={{ height: "74%" }}></span><small>Apr</small></div>
                      <div><span style={{ height: "68%" }}></span><small>May</small></div>
                      <div><span style={{ height: "88%" }}></span><small>Jun</small></div>
                    </div>
                  </div>
                </div>
                <div className="yt-sms-chart-footer">
                  <div><span className="yt-sms-legend-blue"></span>Attendance</div>
                  <div><span className="yt-sms-legend-orange"></span>Performance</div>
                  <div><span className="yt-sms-legend-dark"></span>Collection</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECURITY */}
        <section id="security" className="yt-sms-section yt-sms-security-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-centered yt-sms-reveal">
              <span className="yt-sms-section-number">07 / SECURITY & QUALITY</span>
              <h2>Built with<span> control, validation & confidence.</span></h2>
              <p>School management system mein data, permissions aur application quality ko development ke har stage par carefully consider kiya jata hai.</p>
            </div>

            <div className="yt-sms-side-loop-shell yt-sms-reveal" aria-label="Security and quality features">
              <div className="yt-sms-side-loop-track">
                {[...securityFeatures, ...securityFeatures].map((item, index) => (
                  <article className="yt-sms-feature-loop-card" key={`${item.number}-${index}`}>
                    <div className="yt-sms-feature-loop-top"><span>{item.tag}</span><strong>{item.number}</strong></div>
                    <div className="yt-sms-feature-loop-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <div className="yt-sms-feature-loop-bottom"><span>Quality layer</span><b>→</b></div>
                  </article>
                ))}
              </div>
            </div>

            <div className="yt-sms-section-mini-points yt-sms-reveal">
              <span>✓ Controlled access</span><span>✓ Validated inputs</span><span>✓ Tested workflows</span><span>✓ Responsive quality</span>
            </div>
          </div>
        </section>

        {/* USER ROLES */}
        <section id="roles" className="yt-sms-section yt-sms-roles-section">
          <div className="yt-sms-section-container">
            <div className="yt-sms-roles-layout">
              <div className="yt-sms-roles-copy yt-sms-reveal">
                <span className="yt-sms-section-number">08 / USER EXPERIENCE</span>
                <h2>One platform.<span> Different user journeys.</span></h2>
                <p>Har user ko same complicated interface dene ke bajay, system ko role-based experience ke around structure kiya ja sakta hai.</p>
                <div className="yt-sms-roles-highlight">
                  <div><strong>04</strong><span>Core user roles</span></div>
                  <div><strong>01</strong><span>Connected platform</span></div>
                  <div><strong>360°</strong><span>School workflow</span></div>
                </div>
              </div>

              <div className="yt-sms-roles-grid">
                {userRoles.map((role, index) => (
                  <article className="yt-sms-role-card yt-sms-reveal" key={role.title} style={{ transitionDelay: `${index * 80}ms` }}>
                    <div className="yt-sms-role-card-top"><span>{role.number}</span><div className="yt-sms-role-icon">{role.icon}</div></div>
                    <h3>{role.title}</h3>
                    <p>{role.text}</p>
                    <div className="yt-sms-role-features">
                      {role.features.map((feature) => (<span key={feature}>✓ {feature}</span>))}
                    </div>
                    <div className="yt-sms-role-card-arrow">Explore role<b>↗</b></div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* DELIVERY */}
        <section id="delivery" className="yt-sms-section yt-sms-delivery-section">
          <div className="yt-sms-delivery-orb yt-sms-delivery-orb-one"></div>
          <div className="yt-sms-delivery-orb yt-sms-delivery-orb-two"></div>

          <div className="yt-sms-section-container">
            <div className="yt-sms-section-heading yt-sms-reveal">
              <span className="yt-sms-section-number">09 / DELIVERY & SUPPORT</span>
              <h2>A clear path<span> from build to launch.</span></h2>
              <p>Development complete hone ke baad bhi product journey continue karti hai — review, deployment aur future improvements ko clear workflow ke saath manage kiya ja sakta hai.</p>
            </div>

            <div className="yt-sms-delivery-timeline">
              {deliverySteps.map((step, index) => (
                <article className="yt-sms-delivery-card yt-sms-reveal" key={step.number} style={{ transitionDelay: `${index * 90}ms` }}>
                  <div className="yt-sms-delivery-number">{step.number}</div>
                  <div className="yt-sms-delivery-icon">{step.icon}</div>
                  <div className="yt-sms-delivery-content">
                    <span>STAGE {step.number}</span>
                    <h3>{step.title}</h3>
                    <p>{step.text}</p>
                  </div>
                  <div className="yt-sms-delivery-arrow">→</div>
                </article>
              ))}
            </div>

            <div className="yt-sms-delivery-bottom yt-sms-reveal">
              <div><span className="yt-sms-delivery-status"></span><strong>Ready for the next phase</strong></div>
              <p>Planning → Development → Testing → Deployment → Support</p>
            </div>
          </div>
        </section>

        {/* CONTACT */}
        <section id="contact" className="yt-sms-section yt-sms-contact-section">
          <div className="yt-sms-contact-glow yt-sms-contact-glow-one"></div>
          <div className="yt-sms-contact-glow yt-sms-contact-glow-two"></div>

          <div className="yt-sms-section-container">
            <div className="yt-sms-contact-layout">
              <div className="yt-sms-contact-copy yt-sms-reveal">
                <span className="yt-sms-section-number">07 / START A PROJECT</span>
                <h2>Have a school management<span> idea?</span></h2>
                <p>Apni requirements share karein. Yashvitech requirement discussion se deployment tak complete development journey plan kar sakta hai.</p>
                <div className="yt-sms-contact-points">
                  <div><span>01</span><strong>Requirement Discussion</strong><small>Understand the actual need</small></div>
                  <div><span>02</span><strong>UI / UX Planning</strong><small>Plan the user experience</small></div>
                  <div><span>03</span><strong>Development & Testing</strong><small>Build and verify the system</small></div>
                  <div><span>04</span><strong>Deployment & Support</strong><small>Launch and maintain</small></div>
                </div>
              </div>

              <form className="yt-sms-contact-form yt-sms-reveal" onSubmit={handleSubmit}>
                <div className="yt-sms-form-header">
                  <div><span>PROJECT ENQUIRY</span><h3>Let's build something useful.</h3></div>
                  <div className="yt-sms-form-header-icon">↗</div>
                </div>

                <div className="yt-sms-form-row">
                  <div className="yt-sms-form-group">
                    <label>Your Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required />
                  </div>
                  <div className="yt-sms-form-group">
                    <label>School / Organization</label>
                    <input type="text" name="school" value={formData.school} onChange={handleChange} placeholder="School name" required />
                  </div>
                </div>

                <div className="yt-sms-form-row">
                  <div className="yt-sms-form-group">
                    <label>Email Address (optional)</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" />
                  </div>
                  <div className="yt-sms-form-group">
                    <label>Phone Number (optional)</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 98765 43210" />
                  </div>
                </div>

                <div className="yt-sms-form-group">
                  <label>Project Requirement</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Tell us about your school management system..." rows="5" required></textarea>
                </div>

                <button className="yt-sms-submit-button" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Send Project Enquiry"}
                  {!loading && <span>→</span>}
                </button>

                <small className="yt-sms-form-note">
                  Enter at least one — Email or Phone — so we can reach you back.
                </small>
              </form>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="yt-sms-site-footer">
        <div className="yt-sms-footer-container">
          <div className="yt-sms-footer-brand">
            <button className="yt-sms-footer-logo-button" onClick={() => scrollToSection("home")}>
              <img src={schoolImage} alt="YashviTech" />
            </button>
            <p>Building modern digital solutions around real business requirements.</p>
            <div className="yt-sms-footer-status"><span></span>Available for new projects</div>
          </div>

          <div className="yt-sms-footer-links">
            <div>
              <strong>PROJECT</strong>
              <button onClick={() => scrollToSection("process")}>Workflow</button>
              <button onClick={() => scrollToSection("modules")}>Modules</button>
              <button onClick={() => scrollToSection("analytics")}>Analytics</button>
              <button onClick={() => scrollToSection("security")}>Security</button>
              <button onClick={() => scrollToSection("roles")}>Roles</button>
              <button onClick={() => scrollToSection("delivery")}>Delivery</button>
            </div>
            <div>
              <strong>COMPANY</strong>
              <button onClick={() => scrollToSection("home")}>Home</button>
              <button onClick={() => scrollToSection("reviews")}>Reviews</button>
              <button onClick={() => scrollToSection("contact")}>Contact</button>
            </div>
          </div>
        </div>

        <div className="yt-sms-footer-bottom">
          <span>© 2026 Yashvitech. All rights reserved.</span>
          <span>School Management System • Client Project</span>
        </div>
      </footer>
    </div>
  );
}

export default Landing;